//require('dotenv').config({ path: './.env' });

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

import './assets/css/reset.css'

import clickOutside from './plugins/click-outside'

window.store = store  // Expose the store on the window object so it can be accessed in new windows

// force a fresh login on every new browser session (sessionStorage does not
// survive a full browser close, but does survive an F5 refresh or a tab
// opened via window.open from an already-logged-in tab)
const SESSION_FLAG = 'sessionActive'
if (!sessionStorage.getItem(SESSION_FLAG)) {
  // No marker => a fresh browser open OR a manually opened new tab (copy/paste
  // URL). Force THIS tab to log in again, but pass broadcast:false so we do NOT
  // signal other live tabs to log out (no cross-tab cascade).
  store.dispatch('logout', { broadcast: false })
  localStorage.removeItem('expiresAt')
  // send this tab straight to its login page instead of an empty inner page
  window.location.hash = window.location.hash.startsWith('#/admin') ? '#/admin/login' : '#/'
}
sessionStorage.setItem(SESSION_FLAG, '1')

createApp(App).use(store).use(router).use(clickOutside).mount('#app')



// แนบ token ทุก request อัตโนมัติ
axios.interceptors.request.use(config => {
  const token = store.state.token || localStorage.getItem('token')
  if (token) config.headers.Authorization = `Bearer ${token}`
  return config
})

// admin routes go back to the admin login page, everything else to '/'
function loginRedirectPath() {
  return window.location.hash.startsWith('#/admin') ? '/admin/login' : '/'
}

// ถ้าโดน 401 → logout + ส่งกลับหน้า login
axios.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      store.dispatch('logout')
      router.push(loginRedirectPath())
    }
    return Promise.reject(err)
  }
)

// cross-tab sync: only a REAL logout (button / 401 / expiry) sets logoutBroadcast,
// so a fresh-tab force-login (which does not set it) will not drag this tab out.
window.addEventListener('storage', (e) => {
  if (e.key === 'logoutBroadcast' && e.newValue) {
    store.dispatch('logout', { broadcast: false })
    router.push(loginRedirectPath())
  }
})